import { useEffect } from 'react'

import { SupportLocale } from '@local/utils/dist/i18n/i18n'

import { useModal } from '@web/components/Modal/useModal'
import useReactiveSessionStorage from '@web/hooks/useReactiveSessionStorage'
import { IS_DEV } from '@web/libs/constants'
import MyplaceDevtoolsModal from '@web/libs/dev/MyplaceDevtools/MyplaceDevtoolsModal/MyplaceDevtoolsModal'
import { langVar } from '@web/libs/translate/translate.state'

export const LOCALE_DEBUG: SupportLocale = 'ko'
export const useGlobalMyplaceDevtools = () => {
  const { openModal } = useModal(MyplaceDevtoolsModal)
  const [debugLocale] = useReactiveSessionStorage<SupportLocale>(LOCALE_DEBUG)

  if (debugLocale) langVar(debugLocale)

  const handleKeyDown = (event: KeyboardEvent): void => {
    if (event.ctrlKey && (event.key === 'd' || event.key === 'ㅇ')) {
      event.preventDefault() // 기본 동작 방지
      openModal()
    }
  }

  useEffect(() => {
    if (!IS_DEV) return () => {}

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
}
